import messageMap from "./MessageMaps";

export function importShinyNeuron(index) {
    return require(`assets/images/currencies/shiny neurons/shiny_neuron_${index}.svg`);
}

export function getAlt(index) {
    return index + messageMap("shinyNeurons.hexagonEnclosedShinyNeurons", "image");
}